<template>
  <div class="af-page" v-if="showRechargeSuc">
    <div :class="'af-recharge-suc '+(isSVip?'svip':'')" >
      <div class="no-svip" v-if="!isSVip">
        <img class="top-img" src="../../assets/imgs/recharge-suc-img.png">
        <div class="content-info-panel">
          <div class="coins-lbl" v-text="'Coins +'+coins"></div>
          <div class="suc-lbl"><span v-if="type==1">Recharged succesfully</span><span v-if="type==2" style="color: #1E2028">You need to link your account with email to not lose your account</span></div>
        </div>
      </div>
      <div class="btm-action-panel" @click="hideSelf()" v-if="type==1">OK</div>
      <div class="btm-action-panel" @click="toSignup()" v-if="type==2">Sign up now</div>
    </div>
  </div>


</template>

<script>
import {wrapVal} from "../../utils/tools";

export default {
  name: "rechargesuccess",
  props:{
    coins:{
      type:Number,
      default:0
    },
    type:{
      type:Number,
      default:1, //1-普通充值 2-游客充值
    },
    showRechargeSuc:{
      type:Boolean,
      default:false
    },
    isSVip:{
      type:Boolean,
      default:false
    }

  },
  methods:{
    hideSelf(){
      this.$emit('hideRechargeSuc')
    },
    toSignup(){
      this.$emit('toSignupAf')
      this.hideSelf()
    }

  },
  watch:{
    showRechargeSuc(n,o){
      let target=this
      if (n){
        setTimeout(function () {
          // target.hideSelf()
        },5000)
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "~styles/index.less";
@import "~styles/variable.less";
.af-page{
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,.3);
}
.af-recharge-suc{
  .w(540);
  .h(584);
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.af-recharge-suc.svip{
  .h(529);
  background: url(../../assets/imgs/svip-rs-bg.png) no-repeat;
  background-size: contain;

  .btm-action-panel{
    background: none;
    .btm(10);
    color: #842F0C;
  }
}

.top-img {
  .w(310);
  .h(280);
}
.content-info-panel{
  .w(540);
  .h(326);
  .b-radius(24,24,0,0);
  background: #fff;
  .mt(-106);
  text-align: center;
}
.btm-action-panel{
  .w(540);
  .h(84);
  .b-radius(0,0,24,24);
  background:#FF0E74;
  position: absolute;
 .fs(32);
  font-family: Gilroy-Bold;
  font-weight: bold;
  color: #FFFFFF;
  .lh(84)

}
.coins-lbl {
  .w(540);
  text-align: center;
  .mt(148);
  .fs(36);
  font-family: Gilroy-Bold, Gilroy;
  font-weight: bold;
  color: #7AD9F0;
  .lh(43);
  position: absolute;
}

.suc-lbl {
  .w(540);
  text-align: center;
  position: absolute;
  .mt(29);
  .mt(216);
  .fs(28);
  font-family: Gilroy-Bold, Gilroy;
  font-weight: bold;
  color: #9AA3AF;
  .lh(33);
}


</style>



// WEBPACK FOOTER //
// src/pages/mine/rechargesuccess.vue